import React from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import VideoDetail from '../../../how-to-videos/components/VideoDetail'
import {getVideoThumbnail} from '../../../../../Utils/videoUtils'
import {useHowToVideoByFeature} from '../../../../../hooks/useHowToVideos'
import {NODE_FEATURE_NAME} from './SidebarRight'

const getFeatureName = (featureName: string) => {
  switch (featureName) {
    case NODE_FEATURE_NAME.TRIGGER:
      return 'Trigger'
    case NODE_FEATURE_NAME.SMS:
      return 'SMS Node'
    case NODE_FEATURE_NAME.TIME_DELAY:
      return 'Time Delay'
    case NODE_FEATURE_NAME.CONDITION:
      return 'Conditional Split'
    default:
      return 'Node'
  }
}
const HowToVideosModal: React.FC<{
  show: boolean
  onHide: () => void
  featureName: string
  handleBackToList: () => void
}> = ({show, onHide, featureName, handleBackToList}) => {
  const {video, isLoading, error} = useHowToVideoByFeature(featureName)
  // Handle modal close
  const handleModalHide = () => {
    onHide()
  }

  const handleBack = () => {
    handleBackToList()
  }

  const handleBreadcrumbCategory = () => {}

  return (
    <Modal show={show} onHide={handleModalHide} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className='d-flex align-items-center gap-2'>
            <i className='bi bi-play-circle text-primary fs-4'></i>
            {getFeatureName(featureName)} Tutorial
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0'>
        {isLoading ? (
          <div className='d-flex justify-content-center align-items-center py-10'>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : video ? (
          <VideoDetail
            imagePath={getVideoThumbnail(video)}
            title={video.title}
            description={video.description}
            footerText={video.footerText || ''}
            category={video.category || ''}
            article={video.subTitle || ''}
            item={video}
            onBackToList={handleBack}
            onCategoryClick={handleBreadcrumbCategory}
          />
        ) : (
          <div className='text-center py-10 px-4'>
            <i className='bi bi-video-slash text-muted' style={{fontSize: '4rem'}}></i>
            <h5 className='text-muted mt-4'>No Tutorial Available</h5>
            <p className='text-muted'>
              We haven't created a tutorial for "{getFeatureName(featureName)}" yet. Check back soon
              or contact support for assistance.
            </p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default HowToVideosModal
